// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--i5GK0","aside":"_7a3fb80146--aside--qIRjU","close":"_7a3fb80146--close--Cs24z"};